export default __webpack_public_path__ + "static/media/alert.43724683.svg";